import { InvoiceLinesType, SubscriptionInvoiceLines, TransactionInvoiceLines } from "../adminInvoicingTypes"

type Totals = {
    [key in InvoiceLinesType]?: number
}
type TotalsWithOverall = Totals & {
    overallTotal: number
}

export function calculateTotals(
    invoiceLines: (TransactionInvoiceLines | SubscriptionInvoiceLines)[],
): TotalsWithOverall {
    const totals = invoiceLines.reduce<Totals>((acc, line) => {
        const amountInBasic = line.totalAmount.amount

        acc[line.type] = (acc[line.type] ?? 0) + amountInBasic
        return acc
    }, {})
    const overallTotal = Object.values(totals).reduce((sum, amount) => sum + (amount ?? 0), 0)

    return { ...totals, overallTotal }
}
